import {QueryBuilderConfig} from "angular2-query-builder";
import {Component, Input, OnInit} from "@angular/core";

@Component({
    selector: 'rule-set',
    templateUrl: './rule-set.component.html',
})
export class RuleSetComponent implements OnInit{

    @Input() configData: any;
    @Input() query: any;
    config: QueryBuilderConfig;
    @Input() data: any;
    constructor(){
        this.config = {
            fields: {}
        };
    }
    ngOnInit(): void {
        this.config.fields = this.configData;
    }

}
